/* eslint-disable no-param-reassign */
var DAYS_IN_MS = 24 * 60 * 60 * 1000;
var DatePickerModel = /** @class */function () {
  function DatePickerModel(endDate, singleDateSelect) {
    this.isSelectingStart = false;
    this.isSelectingEnd = false;
    this.singleDateSelect = false;
    this.lastValidEndDate = endDate;
    this.singleDateSelect = singleDateSelect;
    this.dayHolidays = {};
    this.isNotFirstTimeSameLength = false;
  }
  Object.defineProperty(DatePickerModel.prototype, "numberOfNights", {
    get: function () {
      if (this.start && this.end) {
        return Math.round(Math.abs((this.end.getTime() - this.start.getTime()) / DAYS_IN_MS));
      }
      return 0;
    },
    enumerable: false,
    configurable: true
  });
  // Helper method to valid if a given date is between start and end
  DatePickerModel.prototype.isDateSelected = function (date) {
    if (!this.start || !this.end) {
      return false;
    }
    this.setHolidaysSelection();
    return date.getTime() >= this.start.getTime() && date.getTime() <= this.end.getTime();
  };
  /*
   * Use this method to set dates for the model.
   * Setting start and end directly will result in bad logic
   * Notes:
   *  You may be tempted to simplify the logic below. Don't. This is easier to reason. Thanks :)
   */
  DatePickerModel.prototype.dateSelected = function (date) {
    // Nothing is selected
    if (!this.start && !this.end) {
      if (this.isSelectingStart) {
        this.start = date;
        this.setCurrentTrigger('end');
      } else if (this.isSelectingEnd) {
        this.end = date;
        this.setCurrentTrigger('start');
      } else {
        this.resetAndSetStart(date);
      }
    } else if (this.start && this.end) {
      // Both dates are selected
      if (this.isSelectingStart) {
        // Keep the same length of stay when reselecting start date
        this.selectStartWithSameLengthOfStay(date);
      } else if (this.isSelectingEnd) {
        this.selectEndWithAvailableStart(date);
      } else {
        this.resetAndSetStart(date);
      }
    } else if (this.start && !this.end) {
      // Only Start date is selected
      if (this.isSelectingStart) {
        this.start = date;
        this.setCurrentTrigger('end');
      } else if (this.isSelectingEnd) {
        this.selectEndWithAvailableStart(date);
      } else {
        this.resetAndSetStart(date);
      }
    } else {
      // Only End date is selected
      // eslint-disable-next-line no-lonely-if
      if (this.isSelectingStart) {
        this.selectStartWithAvailableEnd(date);
      } else if (this.isSelectingEnd) {
        this.end = date;
        this.setCurrentTrigger('start');
      } else {
        this.resetAndSetStart(date);
      }
    }
    this.setHolidaysSelection();
  };
  /*
   * Use this method to set single date for the model.
   */
  DatePickerModel.prototype.singleDateSelected = function (date) {
    this.start = date;
    this.end = undefined;
    this.setCurrentTrigger('start');
    this.setHolidaysSelection();
  };
  // Use this method to switch current trigger (TopBar)
  DatePickerModel.prototype.setCurrentTrigger = function (trigger) {
    if (trigger === 'start') {
      this.isSelectingStart = true;
      this.isSelectingEnd = false;
    } else if (trigger === 'end') {
      this.isSelectingStart = false;
      this.isSelectingEnd = true;
    } else {
      this.isSelectingStart = false;
      this.isSelectingEnd = false;
    }
  };
  // Private helper functions for dateSelected(date)
  DatePickerModel.prototype.selectEndWithAvailableStart = function (date) {
    if (this.start && (date.getTime() < this.start.getTime() || date.getTime() === this.start.getTime() && !this.singleDateSelect)) {
      this.resetAndSetStart(date);
    } else {
      this.end = date;
      this.setCurrentTrigger('start');
    }
  };
  DatePickerModel.prototype.selectStartWithAvailableEnd = function (date) {
    if (this.end && date.getTime() >= this.end.getTime()) {
      this.resetAndSetStart(date);
    } else {
      this.start = date;
      this.setCurrentTrigger('end');
    }
  };
  DatePickerModel.prototype.selectStartWithSameLengthOfStay = function (date) {
    var sameLengthOfStayEndDate = new Date(date.getTime() + this.numberOfNights * DAYS_IN_MS); // End must be updated before start
    if (this.lastValidEndDate && this.lastValidEndDate <= sameLengthOfStayEndDate.getTime() || this.isNotFirstTimeSameLength) {
      this.resetAndSetStart(date);
    } else {
      this.isNotFirstTimeSameLength = true;
      this.end = sameLengthOfStayEndDate;
      this.start = date;
      this.setCurrentTrigger('end');
    }
  };
  DatePickerModel.prototype.resetAndSetStart = function (date) {
    this.start = date;
    this.end = undefined;
    this.setCurrentTrigger('end');
  };
  // Helper method to validate if the dates of holiday and calendar are the same (Format of holiday: yyyy-mm-dd)
  DatePickerModel.prototype.isDateHolidayEqual = function (dateHoliday, dateCalendar) {
    return this.holidaysConfigured && dateHoliday.toDateString() === dateCalendar.toDateString();
  };
  // Helper method to validate if the month (in the same year) of holiday and calendar are the same (Format of holiday: yyyy-mm-dd)
  // Format of monthInfoCalendar ({month, name, year})
  DatePickerModel.prototype.isMonthHolidayEqual = function (holiday, monthInfoCalendar) {
    if (this.holidaysConfigured) {
      return holiday.getMonth() === monthInfoCalendar.month && holiday.getFullYear() === monthInfoCalendar.year;
    }
    return false;
  };
  // Configure the holidays according to origin and destination
  DatePickerModel.prototype.configureHolidays = function (holidays) {
    var _this = this;
    this.dayHolidays = {};
    var holidaysOrigin = holidays.filter(function (holiday) {
      return holiday.origin;
    });
    var holidaysDestination = JSON.parse(JSON.stringify(holidays.filter(function (holiday) {
      return !holiday.origin;
    })));
    var holidaysDestinationFiltered = holidaysDestination.filter(function (destination) {
      return !holidaysOrigin.find(function (origin) {
        return origin.date === destination.date && origin.name === destination.name;
      });
    });
    holidaysDestinationFiltered.forEach(function (hd) {
      hd.name += " (".concat(hd.country, ")");
    });
    this.holidays = holidaysOrigin.concat(holidaysDestinationFiltered);
    this.holidays.forEach(function (hd) {
      hd.dateSort = new Date(hd.date.split('-').join('/'));
      hd.dateSort.setHours(0, 0, 0, 0);
      hd.month = hd.dateSort.toLocaleString('default', {
        month: 'short'
      });
      _this.dayHolidays[hd.dateSort.toDateString()] = true;
    });
    this.holidays.sort(function (date1, date2) {
      return date1.dateSort && date2.dateSort && (date1.dateSort.getTime() > date2.dateSort.getTime() || date1.dateSort.getTime() === date2.dateSort.getTime() && date1.origin < date2.origin) ? 1 : -1;
    });
    this.holidaysConfigured = true;
    this.setHolidaysSelection();
  };
  // Helper method to return the holiday names in the dates selected
  DatePickerModel.prototype.setHolidaysSelection = function () {
    if (this.holidaysConfigured && (this.start || this.end)) {
      var start = new Date(this.start);
      start.setHours(0, 0, 0, 0);
      var end = new Date();
      if (this.end) {
        end = new Date(this.end);
        end.setHours(0, 0, 0, 0);
      }
      this.holidaysName = '';
      for (var _i = 0, _a = this.holidays; _i < _a.length; _i++) {
        var holiday = _a[_i];
        if (this.end && holiday.dateSort && holiday.dateSort >= start && holiday.dateSort <= end || !this.end && holiday.dateSort && holiday.dateSort.getTime() === start.getTime()) {
          this.holidaysName = this.holidaysName === '' ? "".concat(holiday.month, " ").concat(holiday.dateSort.getDate(), ": ").concat(holiday.name) : "".concat(this.holidaysName, "  \u2022  ").concat(holiday.month, " ").concat(holiday.dateSort.getDate(), ": ").concat(holiday.name);
        }
      }
    } else {
      this.holidaysName = '';
    }
  };
  return DatePickerModel;
}();
export { DatePickerModel };